import { createContext } from 'react';

export type ScheduleExpectationStatus = 'idle' | 'queued' | 'processing' | 'complete';

export type ScheduleExpectationStatusState = {
  status: ScheduleExpectationStatus;
  appointmentTypeIds: string[] | null;
};

const ScheduleExpectationStatusContext = createContext<ScheduleExpectationStatusState>({
  status: 'idle',
  appointmentTypeIds: null
});

export default ScheduleExpectationStatusContext;
